// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35c85144","455":"f485c3ed","982":"8668cef8"}[chunkId] + ".chunk.js";
};